<template>
    <div class="mt-2">
        <div class="alert alert-danger p-1 text-center" :class="showErrorMessage ? 'visible' : 'invisible'">
            {{ errorMessage }}
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="alert alert-primary p-1 text-center" :class="showSuccessMessage ? 'visible' : 'invisible'">
            {{ successMessage }}
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
    </div>
</template>

<script lang="ts">
import { Component, Watch, Vue } from 'vue-property-decorator'
import credentialsStore from '../store/credentials-store'

@Component({ store: credentialsStore })
export default class Notification extends Vue
{
    get successMessage()
    {
        return this.$store.state.successMessage;
    }

    get errorMessage()
    {
        return this.$store.state.errorMessage;
    }

    get showSuccessMessage()
    {
        return this.successMessage.length;
    }

    get showErrorMessage()
    {
        return this.errorMessage.length;
    }
}
</script>
